import React from 'react';
import { ButtonGroup, DashboardLogo } from '@fourthwall/components';
import { routing } from '../../../../utils/routing';
import * as S from './styled';
export const IframePreview = ({ headline, status, buttons, dropdown, iframeSrc, }) => (React.createElement(S.Container, null,
    React.createElement(S.HeaderDesktop, null,
        React.createElement(S.HeaderLogo, null,
            React.createElement(DashboardLogo, { to: routing.home.toString(), color: "inherit" })),
        React.createElement(S.Headline, null,
            React.createElement("h4", null, headline),
            " ",
            status),
        React.createElement(S.HeaderButtons, null,
            React.createElement(ButtonGroup, { space: "large" },
                buttons,
                dropdown))),
    React.createElement(S.HeaderMobile, null,
        React.createElement(S.MobileTop, null,
            React.createElement(DashboardLogo, { to: routing.home.toString(), color: "inherit" }),
            dropdown),
        React.createElement(S.MobileHeadline, null,
            headline,
            " ",
            React.createElement("div", { style: { display: 'inline-block', marginLeft: '4px' } }, status)),
        React.createElement(S.MobileButtons, null,
            React.createElement(ButtonGroup, { space: "medium" }, buttons))),
    React.createElement("div", null,
        React.createElement(S.PreviewIframe, { src: iframeSrc }))));
